Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = require('./constants');

var _bn = require('bn.js');

var _bn2 = _interopRequireDefault(_bn);

var _formatNumber = require('./formatNumber');

var _formatNumber2 = _interopRequireDefault(_formatNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Format a number of token.
 */
exports['default'] = function (number, format) {
    var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var unit = arguments[3];
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _constants.DEFAULT_OPTIONS;

    if (number instanceof _bn2['default']) {
        number = number.toString(10);
    }

    var numberOfMissingZeros = decimals - number.length;

    // pad with 0 on left
    number = '' + String(new Array(numberOfMissingZeros > 0 ? numberOfMissingZeros : 0).join('0')) + String(number);

    // place the decimal point
    number = String(number.slice(0, -decimals)) + '.' + String(number.slice(-decimals));

    // console.log('number.substr(decimals)', number.substr(-1, decimals));

    return (0, _formatNumber2['default'])(number, format, unit, Object.assign({}, _constants.DEFAULT_OPTIONS, options));
};

module.exports = exports['default'];
//# sourceMappingURL=formatToken.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethtools/build/formatToken.js
// module id = pSmK
// module chunks = 0